import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    border-radius: ${spacing(2)};
    inline-size: 100%;
    block-size: 100%;
    overflow: hidden;
  `,
  skeleton: css`
    animation: loading 1.5s infinite;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.05) 0%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(0, 0, 0, 0.05) 100%
    );
    background-color: ${cssTheme.default.day.controlMinor};
    background-size: 200% 100%;
    block-size: 100%;
    inline-size: 100%;

    @keyframes loading {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `,
}
